import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, crudUpdateMany, translate } from 'react-admin';

class MoveToPaidButton extends Component {
    handleClick = () => {
        const { basePath, crudUpdateMany, resource, selectedIds } = this.props;
        crudUpdateMany(resource, selectedIds, { status: 'paid' }, basePath);
    };

    render() {
        return (
            <Button label={this.props.translate(`resources.payments.moveto.paid`)} onClick={this.handleClick} />
        );
    }
}

export default translate(connect(undefined, { crudUpdateMany })(MoveToPaidButton));